import moment, { Moment } from "moment";

export type Schedule = {
  startAt: Moment;
  endAt: Moment;
  title: string;
  // 省略時は defaultMessage を表示する。改行(\n)はそのまま改行として表示される
  message?: string;
}

export const defaultMessage = `データメンテナンスを実施しております。
誠に申し訳ございませんが、メンテナンス中はサービスのご利用を停止させていただいております。
受講者様には大変ご迷惑をお掛けし大変申し訳ございません。
今しばらくお待ちいただけますようお願い申し上げます。`;

export const schedules: Array<Schedule> = [
  {
    startAt: moment('2026-10-22T22:00:00+0900'),
    endAt: moment('2026-10-26T06:00:00+0900'),
    title: '令和8年10月22日(木)22:00～10月26日(月)06:00',
    message: `【重要】緊急メンテナンスに伴う『河合塾One』サービス一時停止のお知らせ

受講生各位

平素より『河合塾One』をご利用いただき、誠にありがとうございます。

PHPの脆弱性に関するセキュリティ上の注意喚起を受け、昨夜、暫定対応として臨時メンテナンスを実施いたしました。
その後、さらなる安全確保のための対応および確認が必要と判断し、本日22日(木)午後10時より26日(月)までを予定し、「河合塾One」サービスを一時停止いたします。
なお、現時点で、本脆弱性を悪用した被害や、ご利用の皆さまのデータの流出は確認されておりません。

■対象メニュー
・河合塾One　　　　　　・管理者用ページ
・トレーナー用ページ　　・保護者用ページ

再開時期が変更した場合は、改めてご案内申し上げます。

ご利用中の皆さまには、多大なるご不便、ご迷惑をおかけしておりますことを深くお詫び申し上げます。
何卒ご理解、ご協力を賜りますよう、よろしくお願い申し上げます。

■お問い合わせ窓口
メール：info_one@kawaijukuone.co.jp
電話：03-6811-5547（対応時間：平日10:00〜17:00）`,  },
];

export const getCurrentSchedule = (now: Moment, schedules: Array<Schedule>): Schedule | undefined => {
  return schedules.find(x => x.endAt > now && now >= x.startAt)
}
